export default "__VITE_ASSET__B32M6vRn__"